<template>
  <div class="space-y-2 mb-8">
    <h3 class="text-lg font-semibold">Reservation successfully deferred</h3>
    <p class="text-sm text-gray-600">The reservation was deferred to the destination statement shown below.</p>
  </div>

  <div class="flex items-center gap-6 *:flex-1">
    <div class="space-y-2">
      <p class="font-medium text-xs text-gray-700 ml-1">Reservartion deferred</p>
      <app-card body-class="space-y-1 p-3!">
        <p class="font-semibold text-sm">{{ reservationSupplierName }}</p>
        <div class="text-gray-600 text-xs">
          <p>{{ reservationDates }}</p>
          <p>SION ID: {{ reservationPublicId }}</p>
        </div>
      </app-card>
    </div>

    <div class="flex items-center justify-between translate-y-3">
      <app-icon
        name="chevron-right-double"
        class="text-primary opacity-15"
        size="sm"
      />
      <app-icon
        name="chevron-right-double"
        class="text-primary"
        size="sm"
      />
      <app-icon
        name="flip-forward"
        variant="gradient"
        color="primary"
        size="xl"
      />
      <app-icon
        name="chevron-right-double"
        class="text-primary"
        size="sm"
      />
      <app-icon
        name="chevron-right-double"
        class="text-primary opacity-15"
        size="sm"
      />
    </div>

    <div class="space-y-2">
      <p class="font-medium text-xs text-gray-700 ml-1">Destination statement</p>
      <app-card
        class="border-transparent ring-2 ring-primary"
        body-class="space-y-1 p-3!"
      >
        <p class="font-semibold text-sm">{{ statementPublicId }}</p>
        <p class="text-gray-600 text-xs">{{ statementDates }}</p>
      </app-card>
    </div>
  </div>
  <div class="flex justify-end">
    <button
      class="btn btn-link"
      @click="goToStatement"
    >
      Go to new statement
      <app-icon
        name="arrow-right"
        size="sm"
      />
    </button>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue';
import { useRouter } from 'vue-router';
import { formatDate } from '@/utils/dates';

const props = defineProps({
  statement: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

const router = useRouter();
const reservation = inject('reservation');

const statementPublicId = computed(() => props.statement?.public_id);
const statementDates = computed(
  () => `${formatDate(props.statement?.start_date)} - ${formatDate(props.statement?.end_date)}`
);

const reservationPublicId = computed(() => reservation.value?.public_id);
const reservationSupplierName = computed(() => reservation.value?.supplier?.name);
const reservationDates = computed(
  () => `${formatDate(reservation.value?.start_date)} - ${formatDate(reservation.value?.end_date)}`
);

const goToStatement = async () => {
  await router.push({
    name: 'statement-details-reservations',
    params: { statementId: props.statement?.id },
  });
  router.go(0);
};
</script>
